export default __webpack_public_path__ + "static/media/twitter-blk.ca414d0a.svg";